import {AbstractModel} from './abstract-model';

export class RunnableCommand extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  command: string | null = null;
  arguments: {} = {};
  options: {} = {};

  buildCommandLine(): string {
    let optionString = '';

    if (this.options) {
      for (const [key, value] of Object.entries(this.options)) {
        if (value === true) {
          optionString += ` ${key}`;
        } else if (value) {
          optionString += ` ${key}=${value}`;
        }
      }
    }

    return `${this.command ?? ''} ${Object.values(this.arguments ?? {})} ${optionString}`;
  }
}
